module.exports = __webpack_public_path__ + "static/media/logo-plus.ba9c32f5.svg";